/* eslint-disable @typescript-eslint/no-unused-expressions */
import { energyApi } from "utilities/Axios";

function subtractHours(date: any) {
  date.setHours(date.getHours() - 720);
  return date;
}

const dateNow = new Date();
const dateTime = subtractHours(dateNow);

export const getAllExpressions = () => {
  return energyApi.get("/ExpMeta/GetAllExpressions");
};

export const getExpressionById = (id: any) => {
  return energyApi.get(`/ExpMeta/GetExpression?id=${id}`);
};

export const getExpressionByEquipment = (id: any) => {
  return energyApi.get(`/ExpMeta/GetExpressionByEquipment?id=${id}`);
};

export const getExpressionByUnit = (id: any) => {
  return energyApi.get(`/ExpMeta/GetExpressionByUnit?id=${id}`);
};

export const getExpressionByTrain = (id: any) => {
  return energyApi.get(`/ExpMeta/GetExpressionByTrain?id=${id}`);
};

export const getExpressionData = (
  ids: any,
  dateTime?: string
) => {
  let url = "Dashboard/GetExpData";
  dateTime ? (url += `?dateTime=${dateTime}`) : null;
  return energyApi.post(url, ids);
};

export const createExpression = (expression: any) => {
  return energyApi.post("/ExpMeta/CreateExpression", expression);
};

export const updateExpression = (expression: any) => {
  return energyApi.post("/ExpMeta/UpdateExpression", expression);
};

export const deleteExpression = (id: any) => {
  return energyApi.get(`/ExpMeta/DeleteExpression?id=${id}`);
};

export const deleteExpressions = (ids: any) => {
  return energyApi.post(`/ExpMeta/DeleteExpressions`, ids);
};

export const validateExpression = (expression: any) => {
  return energyApi.post("/ExpMeta/ValidateExpression", expression);
};

export const downloadExp = (expressionId: any) => {
  return energyApi.get(`/ExpData/DownloadExpData?id=${expressionId}`);
};